module.exports = __webpack_public_path__ + "static/media/snow_groomer.4fcde903.svg";